import React, { useState, useEffect } from "react";
import { Line } from "@ant-design/plots";
import { useSelector } from "react-redux";
import moment from "moment";

const ProgressGraph = (props) => {
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    getInterval();
  }, []);

  function getInterval() {
    const duration =
      (moment(perfCycleState?.endingOn) - moment(perfCycleState?.startingOn)) /
      (1000 * 60 * 60 * 24);

    setDuration(duration);
  }

  function generateGraphData() {
    const data = [
      {
        Date: moment(perfCycleState?.startingOn).format("DD.MM.YYYY"),
        scales: 0,
        category: "Current",
      },
    ];
    for (let i = 0; i < duration + 1; i++) {
      data.push({
        Date: moment(perfCycleState?.startingOn)
          .add(i, "days")
          .format("DD.MM.YYYY"),
        scales: ((i * 100) / duration).toFixed(2),
        category: "Expected",
      });
    }

    data.push({
      Date: getCurrentDate().format("DD.MM.YYYY"),
      scales: props.currentProgress,
      category: "Current",
    });

    return data;
  }

  function getCurrentDate() {
    let output = moment();

    if (moment() < moment(perfCycleState?.startingOn)) {
      output = moment(perfCycleState?.startingOn);
    } else if (moment() > moment(perfCycleState?.endingOn)) {
      output = moment(perfCycleState?.endingOn);
    } else {
      output = moment();
    }

    return output;
  }

  const config = {
    data: generateGraphData(),
    height: 150,
    padding: "auto",
    xField: "Date",
    yField: "scales",
    seriesField: "category",
    xAxis: {
      tickCount: 5,
    },
    yAxis: {
      maxLimit: 100,
    },
  };

  return <Line {...config} />;
};

export default ProgressGraph;
